module.exports = {
	"rounds": [
		{
			"text1": "",
			"text2": "",
			"text3": ""
		},
		{
			"text1": "What to expect",
			"text2": "Change in Customers’ Preferences",
			"text3": "Customer preferences are expected to change for some customers. Therefore, review <b>Round 2</b> Customer Analysis to ensure your product still meets the minimum requirements for the customers that you are targeting."
		},
		{
			"text1": "What to expect",
			"text2": "Change in Customers’ Preferences",
			"text3": "Customer preferences are expected to change for some customers. Therefore, review <strong>Round 3</strong> Customer Analysis to ensure your product still meets the minimum requirements for the customers that you are targeting."
		},
		{
			"text1": "What to expect",
			"text2": "Customer Preferences",
			"text3": "Customer preferences are expected to change for some customers. Therefore, review <strong>Round 4</strong> Customer Analysis to ensure your product still meets the minimum requirements for the customers that you are targeting."
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/onboarding/customer-preferences.json
// module id = 1918
// module chunks = 0